import "./telegramChannel.scss";
import React from "react";
import { TELEGRAM_CHANNEL_URL } from "../../constants/contact";

const TelegramChannel = () => {
  return (
    <section
      className="telegram-channel"
      aria-labelledby="telegram-channel-heading"
    >
      <div className="telegram-channel__glow" aria-hidden="true" />
      <div className="telegram-channel__inner">
        <div className="telegram-channel__content">
          <p className="section-label telegram-channel__label">Telegram</p>
          <h2 id="telegram-channel-heading" className="telegram-channel__title">
            Подписывайтесь на наш Telegram
          </h2>
          <p className="telegram-channel__text">
            Акции, новости, обновления и полезная информация публикуются в нашем
            Telegram-канале.
          </p>
          <aside className="telegram-channel__promo" aria-label="Конкурсы и призы">
            <span className="telegram-channel__promo-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                <path d="M12 2l2.4 7.4H22l-6 4.6 2.3 7-6.3-4.6L6 21l2.3-7-6-4.6h7.6L12 2z" />
              </svg>
            </span>
            <p className="telegram-channel__promo-text">
              Подпишитесь на Telegram-канал, участвуйте в конкурсах и выигрывайте
              призы
            </p>
          </aside>
        </div>
        <a
          className="telegram-channel__btn"
          href={TELEGRAM_CHANNEL_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="telegram-channel__btn-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
              <path d="M9.78 15.28 9.5 19.2c.36 0 .52-.16.71-.35l1.7-1.62 3.53 2.58c.65.36 1.11.17 1.28-.6l2.32-10.9h.01c.21-.97-.35-1.35-.98-1.11L3.9 9.78c-.95.37-.93.9-.16 1.14l4.86 1.52 11.28-7.1c.53-.33 1.02-.15.62.18" />
            </svg>
          </span>
          Перейти в Telegram
        </a>
      </div>
    </section>
  );
};

export default TelegramChannel;
